import CtaBand from '../components/CtaBand'
import FaqSection, { faqEntries } from '../components/sections/FaqSection'
import FilmSection from '../components/sections/FilmSection'
import Hero from '../components/sections/Hero'
import InsightsTeaser from '../components/sections/InsightsTeaser'
import Process from '../components/sections/Process'
import Qualities from '../components/sections/Qualities'
import StatBand from '../components/sections/StatBand'
import Testimonials from '../components/sections/Testimonials'
import WhyProfessional from '../components/sections/WhyProfessional'
import { faqJsonLd, useJsonLd, useSeo } from '../lib/seo'

/*
 * The organisation entity is not emitted here. It is in index.html as static
 * JSON-LD, so it reaches crawlers that do not run JavaScript too; repeating it
 * on this route would put two RealEstateAgent nodes in the same document.
 *
 * Built once at module scope - `useJsonLd` compares by reference.
 */
const homeFaqJsonLd = faqJsonLd(faqEntries)

export default function Home() {
  useSeo({
    isHome: true,
    title: 'Startseite',
    description:
      'CASA Hausverwaltung - WEG-Verwaltung, Sondereigentums- und Mietverwaltung in der Region Aldingen. Rückmeldung innerhalb eines Werktages, digitale Prozesse, eigene Objekterfahrung.',
    path: '/',
  })
  useJsonLd(homeFaqJsonLd, 'faq')

  return (
    <>
      <Hero />
      <StatBand />
      <Qualities />
      <WhyProfessional />
      <FilmSection />
      <Process />
      <Testimonials />
      <FaqSection />
      <InsightsTeaser />
      <CtaBand />
    </>
  )
}
